import { useState } from 'react';
import styled from 'styled-components';
import Masonry from 'react-masonry-component';
import SocialItem from '../../molecules/SocialItem';
import { CTATag } from '../../atoms/CTA/CTA.constants';
import CTA from '../../atoms/CTA';
import { useIntl } from 'react-intl';

const StreamContainer = styled.div`
  width: 100%;
  margin: -25px -25px 0 -25px;
  @media (${(props) => props.theme.socialStream.mobileSwitch}) {
    margin: 0;
  }
`;

const StyledSocialItem = styled(SocialItem)`
  margin: 25px 25px 0 25px;
  width: calc(50% - 50px);
  padding-bottom: 35px;

  @media (${(props) => props.theme.socialStream.mobileSwitch}) {
    width: 100%;
    margin: 0 0 50px 0;
    padding-bottom: 0;
  }
`;

const StyledCTA = styled(CTA)`
  margin-top: 40px;
  margin-left: 25px;

  @media (${(props) => props.theme.socialStream.mobileSwitch}) {
    margin-top: 30px;
    margin-left: 0;
    width: 100%;
    button {
      width: 100%;
      display: block;
    }
  }
`;

/**
 * @param {SocialStreamProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SocialStream = ({ items, className }) => {
  const intl = useIntl();
  const loadMore = intl.formatMessage({
    id: 'main.loadMore',
  });
  const paginationStep = 10;
  const [showAmount, setShowAmount] = useState(paginationStep);
  const handleShowMore = () => {
    if (showAmount + paginationStep <= items.length) {
      setShowAmount(showAmount + paginationStep);
    } else {
      setShowAmount(items.length);
    }
  };
  const displayedItems = items.slice(0, showAmount);

  return (
    <StreamContainer className={className}>
      <Masonry updateOnEachImageLoad={false}>
        {displayedItems.map((itemProps) => (
          <StyledSocialItem
            key={`${itemProps.type}-${itemProps.createdAt}`}
            {...itemProps}
          />
        ))}
      </Masonry>
      {items.length > showAmount && (
        <StyledCTA
          skin="SECONDARY"
          text={loadMore}
          title={loadMore}
          type={CTATag.Button}
          handleBtnClick={handleShowMore}
        />
      )}
    </StreamContainer>
  );
};

export default SocialStream;
